import { Route, Routes } from '@angular/router';
import { DetermineMarketComponent } from '@shared/lib/components/determine-market.component';
import { PageNotFoundComponent } from '@shared/lib/modules/page-not-found/components/page-not-found.component';
import { MarketResolver } from '@usana/ux/markets/routing';
import { CmsHomeComponent } from '../../../usana/src/app/components/cms-home/cms-home.component';
import { CmsTypeGuard } from './guards/cms-type.guard';

const SHARED_ROUTES: Route[] = [
  {
    path: 'opportunity',
    loadChildren: () =>
      import('@shared/lib/lazy-modules/opportunity/opportunity.module').then((m) => m.OpportunityModule),
    canMatch: [CmsTypeGuard],
    data: { preload: true, cmsType: 'noncms' },
  },
  {
    path: 'story',
    loadChildren: () => import('@shared/lib/lazy-modules/story/story.module').then((m) => m.StoryModule),
    canMatch: [CmsTypeGuard],
    data: { preload: true, cmsType: 'noncms' },
  },
  {
    path: 'dmca',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/dmca/dmca.module').then((m) => m.DmcaModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'terms',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/terms/terms.module').then((m) => m.TermsModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'terms-policies',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/policies/policies.module').then((m) => m.PoliciesModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'ctsca',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/ctsca/ctsca.module').then((m) => m.CtscaModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'privacy',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/privacy/privacy.module').then((m) => m.PrivacyModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'income',
    loadChildren: () => import('@shared/lib/lazy-modules/income/income.module').then((m) => m.IncomeModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@shared/lib/lazy-modules/legal/gdpr/gdpr.module').then((m) => m.GdprModule),
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
  },
];

const SHARED_FINAL_ROUTES: Route[] = [
  {
    path: '**',
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'cms' },
    component: CmsHomeComponent,
  },
  {
    path: '**',
    canMatch: [CmsTypeGuard],
    data: { cmsType: 'noncms' },
    component: PageNotFoundComponent,
  },
];

export function combineAppAndSharedRoutes(appRoutes: Routes, lastRoutes: Routes): Routes {
  return [
    {
      path: ':marketId',
      component: DetermineMarketComponent,
      resolve: {
        market: MarketResolver,
      },
      children: [
        // Redirect /:marketId to /:marketId/home
        { path: '', redirectTo: 'home', pathMatch: 'full' }, // Redirect empty child path to home
        ...appRoutes,
        ...SHARED_ROUTES,
        ...lastRoutes,
        // CMS and non-CMS catch-all routes
        ...SHARED_FINAL_ROUTES,
      ],
    },
    // Handles /ux/dotcom/ (no marketId)
    {
      path: '',
      component: DetermineMarketComponent,
    },
  ];
}
